import React, { FunctionComponent, Fragment } from 'react';
import { Typography, TTypographyProps } from '@rbx/ui';
import { parseAliasForCompoundTypes } from '../utils/linkableTypeReferenceUtils';
import SimpleLinkableTypeReferenceList from './SimpleLinkableTypeReferenceList';
import SimpleLinkableTypeReference from './SimpleLinkableTypeReference';

export interface LinkableTypeReferenceProps {
  type: string;
  variant?: TTypographyProps['variant'];
  engineRevampEnabled?: boolean;
}

const LinkableTypeReference: FunctionComponent<
  React.PropsWithChildren<LinkableTypeReferenceProps>
> = ({ type, variant = 'code', engineRevampEnabled = false }) => {
  if (type === null || type === undefined || type === '') {
    return null;
  }
  const { outerType, innerTypes, multipleOrTypes } = parseAliasForCompoundTypes({ type });
  // 'Array<InnerType, InnerType2>' --> { outerType: 'Array', genericType: ['InnerType', 'InnerType2'] }
  if (outerType && innerTypes) {
    return (
      <Fragment>
        <SimpleLinkableTypeReference
          type={outerType}
          variant={variant}
          engineRevampEnabled={engineRevampEnabled}
        />
        <Typography variant={variant}>{'<'}</Typography>
        <SimpleLinkableTypeReferenceList
          types={innerTypes}
          variant={variant}
          engineRevampEnabled={engineRevampEnabled}
        />
        <Typography variant={variant}>{'>'}</Typography>
      </Fragment>
    );
  }
  if (multipleOrTypes) {
    return (
      <SimpleLinkableTypeReferenceList
        types={multipleOrTypes}
        variant={variant}
        connector=' | '
        engineRevampEnabled={engineRevampEnabled}
      />
    );
  }
  return null;
};

export default LinkableTypeReference;
